export const environment = {
    environmentLabel: 'dev',
    production: false,
    landingUrl: "https://primerideaccess.dev/",
    apiBaseUrl: "https://api.primerideaccess.dev/api/",
    googlePlaceKey: "AIzaSyA9cTeiDJHwqBw0xv73qKfjv14Ld6w1F8w"
};